import React, { useContext } from "react";
import noteContext from "../context/notes/noteContext";

const Noteitem = (props) => {
  const { note, updateNote, showAlert } = props;

  const context = useContext(noteContext);
  const { deleteNote } = context;

  const handleDelete = () => {
    deleteNote(note._id);
    showAlert("Note deleted successfully", "success");
  };

  return (
    // ⬅️ col-md-3 → col-md-4 (more width)
    <div className="col-md-4">
      {/* ⬅️ h-100 for auto height */}
      <div className="card my-3 h-100">
        <div className="card-body d-flex flex-column">
          
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="card-title mb-0">{note.title}</h5>

            <div>
              <i
                className="far fa-trash-alt mx-2 text-danger"
                style={{ cursor: "pointer" }}
                onClick={handleDelete}
              ></i>

              <i
                className="far fa-edit mx-2 text-primary"
                style={{ cursor: "pointer" }}
                onClick={() => updateNote(note)}
              ></i>
            </div>
          </div>

          {/* ⬅️ flex-grow so content expands */}
          <p className="card-text flex-grow-1">
            {note.description}
          </p>

          <div>
            <span className="badge bg-secondary">{note.tag}</span>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Noteitem;
